<div *ngIf="showBanner$ | async" class="trial-countdown-banner">
  <div class="banner-icon">
    <mat-icon>schedule</mat-icon>
  </div>
  <div class="banner-text">
    <div class="banner-title">
      {{ 'INTL_YOU_ARE_ON_FREE_TRIAL' | translate }}
    </div>
    <div class="banner-countdown" *ngIf="daysRemaining$ | async as days">
      <span *ngIf="days > 0">{{ days }} {{ 'INTL_DAYS_LEFT' | translate }}</span>
      <span *ngIf="days === 0">{{ 'INTL_TRIAL_ENDS_TODAY' | translate }}</span>
    </div>
    <div class="banner-hint" *ngIf="paymentMethodRequired$ | async">
      {{ 'INTL_TRIAL_ADD_BANK_DETAILS_HINT' | translate }}
    </div>
  </div>
  <div class="banner-actions">
    <ng-container *ngIf="paymentMethodRequired$ | async; else upgradeAsPrimary">
      <button
        mat-raised-button
        color="primary"
        (click)="onAddBankDetails()"
        class="upgrade-button add-bank-details-button"
      >
        {{ 'INTL_ADD_BANK_DETAILS' | translate }}
      </button>
      <button mat-stroked-button color="primary" (click)="onUpgrade()" class="upgrade-button secondary-upgrade-button">
        {{ 'INTL_UPGRADE' | translate }}
      </button>
    </ng-container>
    <ng-template #upgradeAsPrimary>
      <button mat-raised-button color="primary" (click)="onUpgrade()" class="upgrade-button">
        {{ 'INTL_UPGRADE' | translate }}
      </button>
    </ng-template>
    <button mat-button (click)="onCancelTrial()" class="cancel-button">
      {{ 'INTL_CANCEL' | translate }}
    </button>
  </div>
</div>
